const React = require("react");
const ReactRedux = require('react-redux');

const Dropdown = require('../components/Dropdown.jsx');
const RequestApproval = require('./buttons/RequestApproval.jsx');
const Bypass = require('./buttons/Bypass.jsx');

const actions = require('../_actions.js');
const constants = require('../constants/deployment.js');

const moment = require('moment-timezone');

function Approval(props) {
	let sent_time = null;
	if (props.date_requested) {
		sent_time = "Sent: " + props.date_requested.format('DD/MM/YYYY h:mma');
	}

	let error = null;
	if (props.error) {
		error = (
			<div className="alert alert-danger">
				<div className="">
					{props.error}
				</div>
			</div>
		);
	}

	return (
		<div className="section">
			{error}
			<header><h4>Approval</h4></header>
			<p>
				Send a request to deploy this release. Once approved, team members will have the ability to deploy this release.<br />
				Only one request can be active at a time, although approval can also be granted by others with the same permissions, e.g. Release managers.
			</p>
			<div>
				<div className="form-group">
					<label htmlFor="approver">Request approval from</label>
					<Dropdown
						name="approver"
						options={props.approvers}
						value={props.approver_id}
						onSelect={props.onApproverSelect}
						disabled={props.disabled}
					/>
				</div>
				<div>
					{sent_time}
				</div>
				<div>
					<RequestApproval /> <Bypass />
				</div>
			</div>
		</div>
	);
}

function isDisabled(deployState) {
	if (constants.isApproved(deployState)) {
		return true;
	}
	if (constants.isRejected(deployState)) {
		return true;
	}
	if (constants.isQueued(deployState)) {
		return true;
	}
	if (constants.isDeleted(deployState)) {
		return true;
	}
	return false;
}

const mapStateToProps = function(state) {
	const approvers = [];
	Object.keys(state.environment.approvers).forEach(function(id) {
		const approver = state.environment.approvers[id];
		approvers.push({
			id: approver.id,
			title: approver.email + ' - ' + approver.role
		});
	});

	const current = state.deployment.list[state.deployment.current_id] || {};
	var error = state.approval.error;
	if (constants.isDeleted(current.state)) {
		error = 'This deployment has been deleted.';
	}

	let date_requested = null;
	if (current.date_requested_unix) {
		date_requested = moment.unix(current.date_requested_unix)
			.tz(state.user.timezone);
	}
	return {
		date_requested: date_requested,
		disabled: isDisabled(current.state),
		approvers: approvers,
		approver_id: current.approver_id,
		error: error
	};
};

const mapDispatchToProps = function(dispatch) {
	return {
		onApproverSelect: function(id) {
			dispatch(actions.setApprover(id));
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Approval);
